import { useCallback } from 'react';

export default useCallback;
